(ns frontend.ui.component.lp-portal.report.body.sparkmind.fund.pdf.pdf
  (:require
   [frontend.ui.component.lp-portal.report.body.sparkmind.fund.pdf.pages.toc-page :as toc]
   [frontend.ui.component.lp-portal.report.body.sparkmind.fund.pdf.pages.fund-overview :as fund-overview]
   [frontend.ui.component.lp-portal.report.body.sparkmind.fund.pdf.pages.fund-status :as fund-status]
   [frontend.ui.component.lp-portal.report.body.sparkmind.fund.pdf.pages.portfolio-information :as portfolio-information]
   [frontend.ui.component.lp-portal.report.body.sparkmind.fund.pdf.pages.investor-information :as investor-information]
   [frontend.ui.component.lp-portal.report.body.sparkmind.fund.pdf.pages.fees-interest-expenses :as expenses]))


(defn sparkmind-pages
  [data]
  (concat
   (toc/toc-page {:cover-image :front-page-image
                  :report-data data})
   [(fund-overview/fund-overview-page data)]
   (fund-status/fund-status-pages data)
   (portfolio-information/portfolio-information-page data)))

(defn sparkmind-last-pages
  [data]
  (concat
   (investor-information/investor-information-pages data)
   (expenses/fees-interest-expenses data)))

